import DEFINES from '@/defines';
import Login from '../pages/Auth/Login';
import Exit from '@/components/Exit'

import Companies from '../pages/companies/List'
import InvitationForm from '../pages/Invitation/Create.vue';
import Dashboard from '../pages/Avails/Dashboard';
import FilmOverview from '../pages/films/Overview';
import ListInvitations from '../pages/Invitation/List.vue';
import Expired from '@/components/invitation/Expired';
import Wishlist from '@/pages/guest/Wishlist';

export default [

    {
        path: '/',
        redirect: {
            name: 'Login'
        }
    },

    {
        path: '/login',
        name: 'Login',
        meta: {
            layout: DEFINES.LAYOUT_AUTH,
            public: true,
        },
        component: Login
    },
    {
        path: '/exit',
        name: 'Exit',
        meta: {
            layout: DEFINES.LAYOUT_AUTH,
            public: true,
        },
        component: Exit
    },

    // Company
    {
        path: '/companies',
        name: 'Companies',
        meta: {
            layout: DEFINES.LAYOUT_APP,
            backRoute: "Dashboard",
            hideMenu: true
        },
        component: Companies
    },
    // Company films
    {
        path: '/company/:company_id/films',
        name: 'Dashboard',
        meta: {
            layout: DEFINES.LAYOUT_APP,
            hideMenu: false
        },
        component: Dashboard
    },
    {
        path: '/company/:company_id/film/:film_id',
        name: 'FilmOverview',
        meta: {
            layout: DEFINES.LAYOUT_APP,
            backRoute: "Dashboard",
            hideMenu: true
        },
        component: FilmOverview

    },
    // Invitations
    {
        path: "/invite",
        name: "CreateInvitation",
        meta: {
            layout: DEFINES.LAYOUT_APP,
            backRoute: "Dashboard",
            hideMenu: true
        },
        component: InvitationForm
    },
    {
        path: "/invitation/list",
        name: "ListInvitations",
        meta: {
            layout: DEFINES.LAYOUT_APP,
            backRoute: "Dashboard",
            hideMenu: true
        },
        component: ListInvitations
    },
    {
        path: '/company/:company_id/avail/link/:uuid',
        name: 'AccessingAvailLink',
        meta: {
            layout: DEFINES.LAYOUT_APP,
        },

        // Avail link type = http://127.0.0.1:8095/company/1/avail/link/3a50f1b0-125d-11ea-b86e-77dbf635ebed
    },
    // If avail link is expired
    {
        path: '/errorWithAvailLink',
        name: 'Expired',
        meta: {
            layout: DEFINES.LAYOUT_AUTH,
            public: true,
        },
        component: Expired
    },
  {
    path: '/wishlist',
    name: 'Wishlist',
    meta: {
      layout: DEFINES.LAYOUT_APP,
      backRoute: 'Dashboard',
      hideMenu: true,
    },
    component: Wishlist,
  },
];
